import React, { useEffect, useState } from "react";
import {
	Box,
	CircularProgress,
	Container,
	Fade,
	IconButton,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Page from "../../../components/Page";
import { useNavigate } from "react-router-dom";
import {
	getActivitats,
	publicarTotesActivitats,
	despublicarActivitats,
} from "../../../database/API";
import MUIDataTable from "mui-datatables";
import Title from "../../../components/Title";
import { Add } from "@mui/icons-material";
import ActivitatsColumns from "./Table/ActivitatsColumns";
import ActivitatsOptions from "./Table/ActivitatsOptions";
import { Button } from "@mui/material";
import { styled } from "@mui/material";
import { useSnackbar } from "notistack";

const useStyles = styled((theme) => ({
	root: {
		backgroundColor: "white",
		minHeight: "100%",
	},
	container: {
		paddingTop: 40,
		paddingBottom: 80,
	},
}));

const getMuiTheme = () =>
	createTheme({
		overrides: {
			TableHead: {
				root: {
					fontSize: 23,
				},
			},
		},
	});

const ActivitatsAdmin = () => {
	const classes = useStyles();
	const navigate = useNavigate();
	const { enqueueSnackbar } = useSnackbar();
	const [activitats, setActivitats] = useState();
	const [loading, setLoading] = useState(true);
	const [publicantTotes, setPublicantTotes] = useState(false);
	const [despublicantTotes, setDespublicantTotes] = useState(false);

	const filterList = JSON.parse(localStorage.getItem("activitatsFilter"));
	const columns = ActivitatsColumns(activitats, filterList ? filterList : []);

	const filterFunc = (changedColumn, filterList) =>
		localStorage.setItem("activitatsFilter", JSON.stringify(filterList[2]));
	const options = ActivitatsOptions(activitats, filterFunc);

	const getActivitatsList = async () => {
		const { activitats } = await getActivitats(null);
		setActivitats(activitats);
		setLoading(false);
	};

	useEffect(() => {
		getActivitatsList();
	}, []);

	const handlePublicarTotes = async () => {
		if (
			!window.confirm(
				"Segur que vols publicar totes les activitats de cop?",
			)
		) {
			return;
		}
		setPublicantTotes(true);
		const { message, success } = await publicarTotesActivitats();
		enqueueSnackbar(message, { variant: success ? "success" : "error" });
		if (success) {
			await getActivitatsList();
		}
		setPublicantTotes(false);
	};

	const handleDespublicarTotes = async () => {
		if (
			!window.confirm(
				"Segur que vols despublicar totes les activitats de cop?",
			)
		) {
			return;
		}
		setDespublicantTotes(true);
		const { message, success } = await despublicarActivitats();
		enqueueSnackbar(message, { variant: success ? "success" : "error" });
		if (success) {
			await getActivitatsList();
		}
		setDespublicantTotes(false);
	};

	return (
		<Page className={classes.root} title={"Activitats"}>
			<Container maxWidth={false} className={classes.container}>
				<Title
					title={"Activitats"}
					subtitle={"Administra les activitats"}
					button={
						<>
							<Button
								onClick={handlePublicarTotes}
								disabled={publicantTotes}
								startIcon={
									publicantTotes ? (
										<CircularProgress size={16} />
									) : null
								}
							>
								Publicar activitats
							</Button>
							<Button
								onClick={handleDespublicarTotes}
								disabled={despublicantTotes}
								startIcon={
									despublicantTotes ? (
										<CircularProgress size={16} />
									) : null
								}
							>
								Despublicar activitats
							</Button>
							<Button onClick={() => navigate("packs")}>
								Packs
							</Button>
							<IconButton
								className={classes.addButton}
								onClick={() => navigate("nou")}
							>
								<Add />
							</IconButton>
						</>
					}
				/>
				<Box pt={2} spacing={3}>
					{!loading ? (
						<Fade in={!loading}>
							<div>
								<ThemeProvider theme={getMuiTheme()}>
									<MUIDataTable
										data={activitats}
										columns={columns}
										options={options}
									/>
								</ThemeProvider>
							</div>
						</Fade>
					) : (
						<CircularProgress />
					)}
				</Box>
			</Container>
		</Page>
	);
};

export default ActivitatsAdmin;
